<template>
  <img @error="useFallback()">
</template>

<script>
  export default {
    name: 'posterImage',
    methods: {
      useFallback () {
        $(this.$el).attr("src","/static/default-poster.jpg")
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/_global/poster-image.vue